import React, {
  useMemo,
  useState,
} from "react";
import { Plus, Search } from "lucide-react";

export function RecipientPicker({
  replies = [],
  onSelect,
}) {
  const [search, setSearch] =
    useState("");

  const newRecipientReply = useMemo(
    () =>
      replies.find((reply) =>
        String(
          reply?.label || reply?.text || ""
        )
          .toLowerCase()
          .includes("new recipient")
      ),
    [replies]
  );

  const recipients = useMemo(
    () =>
      replies.filter(
        (reply) =>
          reply !== newRecipientReply
      ),
    [replies, newRecipientReply]
  );

  const filteredRecipients =
    useMemo(() => {
      const query = search
        .trim()
        .toLowerCase();

      if (!query) {
        return recipients;
      }

      return recipients.filter(
        (reply) =>
          String(
            reply?.label ||
              reply?.text ||
              ""
          )
            .toLowerCase()
            .includes(query)
      );
    }, [recipients, search]);

  return (
    <div className="w-full space-y-2.5">
      <div className="relative">
        <Search
          size={15}
          className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[#0A2540]/35"
        />

        <input
          type="search"
          value={search}
          onChange={(event) =>
            setSearch(event.target.value)
          }
          placeholder="Search recipients..."
          className="w-full rounded-xl border border-[#0A4730]/10 bg-white py-2.5 pl-9 pr-3 text-sm text-[#0A2540] outline-none transition focus:border-[#0A4730]/30 focus:ring-4 focus:ring-[#0A4730]/5"
        />
      </div>

      <div className="flex min-w-0 items-center gap-2">
        {newRecipientReply && (
          <button
            type="button"
            onClick={() =>
              onSelect(
                newRecipientReply.value ??
                  newRecipientReply.label ??
                  newRecipientReply.text
              )
            }
            className="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-[#0A4730]/15 bg-[#C0F6B7]/45 px-4 py-2 text-sm font-semibold text-[#0A4730] transition hover:bg-[#C0F6B7]/70 active:scale-[0.98]"
          >
            <Plus size={14} />
            New recipient
          </button>
        )}

        <div className="flex min-w-0 flex-1 gap-2 overflow-x-auto pb-1">
          {filteredRecipients.map(
            (reply) => {
              const label =
                reply.label ??
                reply.text ??
                String(reply.value ?? "");

              return (
                <button
                  key={
                    reply.value ??
                    reply.id ??
                    label
                  }
                  type="button"
                  onClick={() =>
                    onSelect(
                      reply.value ??
                        label
                    )
                  }
                  className="shrink-0 rounded-full border border-[#0A4730]/10 bg-white px-4 py-2 text-sm font-medium text-[#0A2540] transition hover:border-[#0A4730]/20 hover:bg-[#C0F6B7]/20 active:scale-[0.98]"
                >
                  {label}
                </button>
              );
            }
          )}

          {filteredRecipients.length ===
            0 && (
            <span className="shrink-0 px-2 py-2 text-xs text-[#0A2540]/40">
              No recipients found
            </span>
          )}
        </div>
      </div>
    </div>
  );
}